import { UpdateSheet } from '../components/AppUpdate';
import { useI18n } from '../i18n';
import { useIntegrity } from '../hooks/useIntegrity';

/**
 * W24 app integrity: only when the server enforces integrity and this copy of the app could not be
 * verified (not installed from Google Play, rooted, emulator …) — a sheet explains how to get the
 * official app. In every other case (mode off, shadow, passed, Google down) nothing shows.
 */
export function IntegrityGate() {
  const { t } = useI18n();
  const integrity = useIntegrity();
  if (!integrity.blocked) return null;
  return (
    <UpdateSheet
      required={false}
      reload={false}
      notes={null}
      onUpdate={integrity.openStore}
      onLater={integrity.retry}
      labels={{
        title: t('integrity.title'),
        body: t('integrity.body'),
        version: null,
        notesTitle: '',
        action: t('integrity.openStore'),
        later: t('integrity.retry'),
      }}
    />
  );
}
